import {
  AUTHENTICATION_FLOW_STATE,
  AuthenticationFlowState
} from '~/src/stores/authentication-flow'
import { useEoState } from '~/src/hooks/useEoState'
import { useEffect } from 'react'
import { UseAuthenticationFlowDialogsReturnType } from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'
import useUpdateCustomerExtraInfo from '~/src/hooks/auth/useUpdateCustomerExtraInfo'
import { BasicResponse } from '@eo-storefronts/eo-core'
import useCustomerProfilePasswordFieldState
  from '~/src/hooks/forms/customer-profile-form/useCustomerProfilePasswordFieldState'

interface ReturnsType {
  onSubmit(): Promise<boolean>,
}

interface Props extends Pick<UseAuthenticationFlowDialogsReturnType, 'end'> {}

const useAuthenticationFlowCustomerMissingFieldsOnSubmit = ({ end }: Props): ReturnsType => {
  const { update: updateCustomerExtraInfo, loading, errors } = useUpdateCustomerExtraInfo()
  const { isRequired: isPasswordRequired } = useCustomerProfilePasswordFieldState()
  const [ authenticationFlowState, setAuthenticationFlowState ] = useEoState<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)

  const onSubmit = async (): Promise<boolean> => {
    if (
      !authenticationFlowState.customer?.email ||
      !authenticationFlowState.customer?.phone ||
      !authenticationFlowState.customer?.firstName ||
      (isPasswordRequired && !authenticationFlowState.customer?.password) ||
      !authenticationFlowState.customer?.lastName
    ) {
      return false
    }

    // Login logic
    const response: BasicResponse | undefined | void = await updateCustomerExtraInfo({
      email: authenticationFlowState.customer.email,
      phone: authenticationFlowState.customer.phone,
      password: authenticationFlowState.customer.password || null,
      firstName: authenticationFlowState.customer.firstName,
      lastName: authenticationFlowState.customer.lastName
    })

    if (!response) {
      return false
    }

    end(true)

    return true
  }

  useEffect(() => {
    setAuthenticationFlowState((state: AuthenticationFlowState) => ({
      ...state,
      isLoading: loading
    }))
  }, [ loading ])

  useEffect(() => {
    setAuthenticationFlowState((state: AuthenticationFlowState) => ({
      ...state,
      errors
    }))
  }, [ errors ])

  return {
    onSubmit
  }
}

export default useAuthenticationFlowCustomerMissingFieldsOnSubmit
